{
  "id": "campaign-123",
  "name": "Rally Stadium II",
  "seed": "campaign:123",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r....QQQQ.,..r",
    "..:x..~...,:..",
    "..:..a~~a.,:..",
    "..::::::::::..",
    ".......#...x..",
    ".a..a....a..a.",
    ".....a..a...,,",
    "::::::::::::::",
    "..............",
    ".a...a..a...a.",
    "..a........a..",
    "..::::::::::..",
    "..:a..#...a:..",
    "..:........:..",
    "S....QQQQ....."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 2,
      "y": 8
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 11,
      "y": 0
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 11
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 3,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 13
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 123,
  "biome": "stadium",
  "par": {
    "reel": 6775,
    "push": 6288,
    "selfPropelled": 5706,
    "tractor": 4635,
    "zeroTurn": 3876,
    "fairway": 2697
  },
  "goldTime": {
    "reel": 6775,
    "push": 5963,
    "selfPropelled": 5394,
    "tractor": 4535,
    "zeroTurn": 3876,
    "fairway": 2213
  },
  "routeTries": {
    "par": {
      "reel": 10,
      "push": 23,
      "selfPropelled": 9,
      "tractor": 9,
      "zeroTurn": 6,
      "fairway": 14
    },
    "gold": {
      "reel": 10,
      "push": 34,
      "selfPropelled": 31,
      "tractor": 49,
      "zeroTurn": 6,
      "fairway": 30
    }
  }
}
